import React from 'react'
import PropTypes from 'prop-types'
import StickyHeader from 'components/StickyHeader'
import StickyHeaderWrapper from 'components/common/StickyHeaderWrapper'
import { MAIN_CONTENT, FOOTER } from 'constant'

const PersonalInformation = ({ placeholders: { footer, header, mainContent }, ...props }) =>
  <React.Fragment>
    <StickyHeaderWrapper>
      { header }
      <StickyHeader />
    </StickyHeaderWrapper>
    <main id={ MAIN_CONTENT } tabIndex="-1" data-max-width data-max-width-padding>
      { mainContent }
    </main>
    <div id={ FOOTER }>
      { footer }
    </div>
  </React.Fragment>

PersonalInformation.propTypes = {
  '@type': PropTypes.string,
  name: PropTypes.string,
  placeholders: PropTypes.shape({
    footer: PropTypes.array,
    header: PropTypes.array,
    mainContent: PropTypes.array
  }),
  title: PropTypes.string
}

PersonalInformation.type = 'Personal Information'
PersonalInformation.placeholders = ['mainContent', 'footer', 'header']

export default PersonalInformation
